import React from 'react';
import TimerMachine from 'react-timer-machine';
import Icon from 'antd/lib/icon';
import {convertMsToHMS, getMilliSeconds} from '../../helpers/util';

class Countdown extends React.PureComponent {

  state = {
    timer: {},
  };

  getTimer = (time) => {
    const {h, m, s} = time;
    return parseInt(h * 60 * 60 + m * 60 + s);
  };

  setTimer = time => {
    this.setState({
      timer: this.getTimer(time),
    });
  };

  getCountdownValue = () => {
    return this.state.timer;
  };

  startHandler = () => {
    this.props.onStarting();
  };

  completeHandler = () => {
    this.props.onComplete();
  };

  render() {
    const {reverse, duration, isStarted} = this.props;

    return (
        <p title={'HH:MM:SS'} style={{display: 'inline-block'}}
           className="mc-mr-20">
          <TimerMachine
              timeStart={getMilliSeconds(duration)}
              started={isStarted}
              paused={false}
              countdown={reverse === undefined}
              interval={1000}
              formatTimer={(time, ms) => convertMsToHMS(ms)}
              onStart={this.startHandler}
              onTick={this.setTimer}
              onComplete={this.completeHandler}
          />
          <Icon className="challenge-exam-timer-icon" type="clock-circle"/>
        </p>
    );
  }
}

export {Countdown};
